/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SpecificAnimaticConfig,
  SpecificAnimaticConfig$inboundSchema,
  SpecificAnimaticConfig$Outbound,
  SpecificAnimaticConfig$outboundSchema,
} from "./specificanimaticconfig.js";

/**
 * The status of the animatic.
 */
export const AnimaticPrimitiveConfigStatus = {
  On: "on",
  Off: "off",
  Faulted: "faulted",
  Estopped: "estopped",
  Oos: "oos",
  WrongMode: "wrong_mode",
} as const;
/**
 * The status of the animatic.
 */
export type AnimaticPrimitiveConfigStatus = OpenEnum<
  typeof AnimaticPrimitiveConfigStatus
>;

/**
 * The configuration of the animatic primitive.
 */
export type AnimaticPrimitiveConfig = {
  /**
   * A configuration for a specific animatic.
   */
  specificAnimaticConfig?: SpecificAnimaticConfig | undefined;
  /**
   * The status of the animatic.
   */
  status: AnimaticPrimitiveConfigStatus;
};

/** @internal */
export const AnimaticPrimitiveConfigStatus$inboundSchema: z.ZodType<
  AnimaticPrimitiveConfigStatus,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticPrimitiveConfigStatus);
/** @internal */
export const AnimaticPrimitiveConfigStatus$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticPrimitiveConfigStatus
> = openEnums.outboundSchema(AnimaticPrimitiveConfigStatus);

/** @internal */
export const AnimaticPrimitiveConfig$inboundSchema: z.ZodType<
  AnimaticPrimitiveConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  specific_animatic_config: types.optional(
    SpecificAnimaticConfig$inboundSchema,
  ),
  status: AnimaticPrimitiveConfigStatus$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "specific_animatic_config": "specificAnimaticConfig",
  });
});
/** @internal */
export type AnimaticPrimitiveConfig$Outbound = {
  specific_animatic_config?: SpecificAnimaticConfig$Outbound | undefined;
  status: string;
};

/** @internal */
export const AnimaticPrimitiveConfig$outboundSchema: z.ZodType<
  AnimaticPrimitiveConfig$Outbound,
  z.ZodTypeDef,
  AnimaticPrimitiveConfig
> = z.object({
  specificAnimaticConfig: SpecificAnimaticConfig$outboundSchema.optional(),
  status: AnimaticPrimitiveConfigStatus$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    specificAnimaticConfig: "specific_animatic_config",
  });
});

export function animaticPrimitiveConfigToJSON(
  animaticPrimitiveConfig: AnimaticPrimitiveConfig,
): string {
  return JSON.stringify(
    AnimaticPrimitiveConfig$outboundSchema.parse(animaticPrimitiveConfig),
  );
}
export function animaticPrimitiveConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticPrimitiveConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticPrimitiveConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticPrimitiveConfig' from JSON`,
  );
}
